import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'Ar roghainn',
  bestPriceBadge: 'Prìs as fheàrr',
  regulatedNotice: {
    prescriptionOnly: 'Le òrdugh-leigheis a-mhàin',
    professionalUse: 'Airson cleachdadh proifeiseanta',
    fromVeterinarian: 'Ri fhaighinn bhon lighiche-sprèidh agad',
    fromPharmacist: 'Ri fhaighinn bho chungadair',
    noOnlinePurchase: 'Cha tèid a reic air-loidhne',
    professionalSupply: 'Ga reic tro sholaraichean proifeiseanta',
    whyNoLink: 'Tha sinn a\' sgrùdadh a\' bhathair seo, ach chan eil sinn a\' cur ceangal thuige.',
  },
};
